<template>
  <div class="columns is-multiline is-marginless is-main-content is-paddingless"
  v-if="critereRecherche">
    <div class="column is-12 pdb-0 hauteur-haut-brief-filtre">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('general.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('general.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div class="column is-12 is-marginless overflow-auto hauteur-brief-filtre">
      <div class="columns is-marginless is-multiline">
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeTypeOt.filtre.types')">
            <qd-taginput v-model="critereRecherche.types"
                        type="is-primary">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <libelle-tag-input
                        :label="$t('listeTypeOt.filtre.actionInterventions')"
                        :items="getActionIntervention"
                        v-model="actionsInterventionsOtSelected">
          </libelle-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeTypeOt.filtre.produit')">
            <qd-taginput icon="magnify"
                        v-model="produitsSelected"
                        :data="filteredProduits"
                        :loading="isFetching"
                        autocomplete
                        field="libelle"
                        type="is-primary"
                        @typing="getFilteredProduits">
              <template slot="empty">
                <div v-if="!isFetching"> {{$t('general.autocomplete.noRslt')}} </div>
                <div v-else>{{$t('general.autocomplete.search')}}</div>
              </template>
            </qd-taginput>
          </b-field>
        </div>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()">
        {{$t('general.button.apply')}}
      </button>

      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()">
        {{$t('general.button.reinitialiser')}}
      </button>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import { SET_CRITERE_RECHERCHE } from '@/store/modules/logistique/typeOt-mutation-type';
import {
  LISTE_ACTION_INTERVENTION,
  LISTE_ACTION_INTERVENTION_IPRESSIONAFFICHE,
  LISTE_ACTION_INTERVENTION_DISPOSITF,
} from '@/configuration/logistique/typeOt/typeOtConfig';
import { getAll } from '@/api/produit/produitDivers';
import { SENS_ACHAT } from '@/configuration/devisConf';
import messageErreur from '@/services/general/messageErreur';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';

const TypeOt = createNamespacedHelpers('typeOt');
const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  data() {
    return {
      critereRecherche: null,
      isFetching: false,
      produitsSelected: [],
      actionsInterventionsOtSelected: [],
      filteredProduits: [],
    };
  },
  components: {
    libelleTagInput,
  },
  computed: {
    ...TypeOt.mapGetters({
      critereRechercheFromStore: 'critereRecherche',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    moduleStockTiersActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleStockTiers.key);
    },
    moduleEmplacementClientActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleEmplacementClient.key);
    },
    getActionIntervention() {
      let interventionsActions = LISTE_ACTION_INTERVENTION;
      if (this.moduleStockTiersActive) {
        interventionsActions = interventionsActions
          .concat(LISTE_ACTION_INTERVENTION_IPRESSIONAFFICHE);
      }
      if (this.moduleEmplacementClientActive) {
        interventionsActions = interventionsActions
          .concat(LISTE_ACTION_INTERVENTION_DISPOSITF);
      }
      return interventionsActions;
    },
  },
  methods: {
    ...TypeOt.mapMutations({
      setCritereRecherche: SET_CRITERE_RECHERCHE,
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    getFilteredProduits: debounce(async function getProduit(search) {
      this.filteredProduits = [];
      if (!search) return;
      this.isFetching = true;
      try {
        const produits = (await getAll(
          {
            query: {
              auto: search,
              sens: SENS_ACHAT,
              societeId: this.societeActiveId,
              actif: true,
            },
          },
        )).data.result.items;
        this.filteredProduits = produits.filter((produit) => {
          return !this.produitsSelected.map(
            produitsSelected => produitsSelected.id,
          ).includes(produit.id);
        });
        this.isFetching = false;
      } catch (e) {
        this.isFetching = false;
        messageErreur(this.$i18n);
        throw (e);
      }
    }, 300),
    viderCritere() {
      this.critereRecherche.actionsInterventionsOt = [];
      this.critereRecherche.produits = [];
      this.critereRecherche.types = [];
      this.produitsSelected = [];
      this.actionsInterventionsOtSelected = [];
    },
    appliquerCritere() {
      this.critereRecherche.actionsInterventionsOt = this.actionsInterventionsOtSelected
        .map((action) => {
          return action.code;
        });
      this.critereRecherche.produits = this.produitsSelected;
      this.setCritereRecherche(this.critereRecherche);
      this.$emit('recherche');
    },
  },
  mounted() {
    this.critereRecherche = cloneDeep(this.critereRechercheFromStore);
    this.produitsSelected = this.critereRecherche.produits;
    if (this.critereRecherche.actionsInterventionsOt.length > 0) {
      this.actionsInterventionsOtSelected = this.getActionIntervention
        .filter((e) => {
          return this.critereRecherche.actionsInterventionsOt.includes(e.code);
        });
    }
  },
};
</script>
